import Api from '../Api'


export class ApiInv extends Api{
    constructor(){
        super()
    }

    async getCategorias(id=-1){
        return await super.get("categoria", id)
    }

    async getCategoriasSite(id=-1){
        return await super.getSite("categoria", id)
    }

    async saveCategoria(obj){
        return await super.save("categoria", obj)
    }

    async delCategoria(id){
        return await super.delete("categoria", id)
    }


    async getSubCategorias(id=-1){
        return await super.get("subcategoria", id)
    }

    async getSubCategoriasSite(id=-1){
        return await super.getSite("subcategoria", id)
    }

    async saveSubCategoria(obj){
        return await super.save("subcategoria", obj)
    }

    async delSubCategoria(id){
        return await super.delete("subcategoria", id)
    }


    async getProdutos(id=-1, dataInicial="", dataFinal="", empresa){
        return await super.get("produto", id, dataInicial, dataFinal, empresa)
    }

    async getProdutosSite(id=-1){
        return await super.getSite("produto", id)
    }

    async getProdutoByName(termo){
        return await super.get("produto/by-descricao", termo)
    
    }

    async getProdutoByNameSite(termo){
        return await super.getSite("produto/by-descricao", termo)
    
    }
    async getProdutoBySubcategoria(termo){
        return await super.getSite("produto/by-subcategoria", termo)
    }

    async saveProduto(obj){
        return await super.save("produto", obj)
    }
    
    async alterarPrecoProduto(obj){
       return await super.saveParcial(`produto/alterarpreco/action`, obj)
       // return await super.saveParcial(`produto/${id}/alterarpreco`, obj)
    }

    async delProduto(id){
        return await super.delete("produto", id)
    }

    async getEmpresas(id=-1){
        return await super.get("empresa", id)
    }

    async saveEmpresa(obj){
        return await super.save("empresa", obj)
    }

    async delEmpresa(id){
        return await super.delete("empresa", id)
    }

    async saveEmail(obj){
        console.log('chegou aqui também', obj)
        return await super.saveSite('email-contato', obj)
    }

    /* Usuários */
    async getUsuarios(id=-1){
        return await super.get("usuario", id)
    }

    async saveUsuario(obj){
        return await super.save("usuario", obj)
    }

    async delUsuario(id){
        return await super.delete("usuario", id)
    }

    /* Cargos */
    async getCargos(id=-1){
        return await super.get("cargo", id)
    }

    async saveCargo(obj){
        return await super.save("cargo", obj)
    }

    async delCargo(id){
        return await super.delete("cargo", id)
    }

    /* Grupos */
    async getGroups(id=-1){
        return await super.get("groups", id)
    }



    /* PRODUCTS */
    async getProducts(id=-1, dataInicial="", dataFinal="", empresa){
        return await super.get("product", id, dataInicial, dataFinal, empresa)
    }
    async saveProduct(obj){
        return await super.save("product", obj)
    }
    async delProduct(id){
        return await super.delete("product", id)
    }
    /* SERVICES */
    async getServices(id=-1, dataInicial="", dataFinal="", empresa){
        return await super.get("service", id, dataInicial, dataFinal, empresa)
    }
    async saveService(obj){
        return await super.save("service", obj)
    }
    /* PLAN */
    async getPlans(id=-1, dataInicial="", dataFinal="", empresa){
        return await super.get("plan", id, dataInicial, dataFinal, empresa)
    }
    async savePlan(obj){
        return await super.save("plan", obj)
    }


    /* ITENS DE PRODUTOS NA VENDA */
    async delItemProductComanda(id){
        return await super.delete("item-produto-venda", id)
    }
    async saveProductComanda(obj){
        return await super.save("item-produto-venda", obj)
    }
}